module.exports = __webpack_public_path__ + "assets/img/icon_user3.d9e848f5.png";